import { FunctionalComponent, h } from "preact";
import { useEffect, useState } from "preact/hooks";
import { route } from "preact-router";
import { getIsEdge, getSearchNumScores } from "../../configs/env";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";

import {
  setExactMatch,
  setKapps,
  setLastQ,
  setLastQResults,
  setSelectedFilters,
  setSummary,
  setTags,
  setLastExactMatch,
  setDocsFilterStatus,
  setYearFilterStatus,
  setTypedYearFrom,
  setTypedYearTo,
  setCategories,
  setSelectedCategory,
  setInputValue,
  setNestedTags,
  setSelectedNestedTags,
  setKeywordsDocuments,
} from "../../redux/slices/searchSlice";

import {
  UpdateEdgeUserSessionTimeStamp,
  Utils,
  convertJson,
  encorderQuestion,
  getEdgeUserLoginSession,
  getSelectedNames,
  sortSearchResultsChronologically,
} from "../../utils";
const axios = require("axios").default;
import { isMobileOnly as isMobileOnlyReact } from "react-device-detect";
import { SelectedDocumentType } from "../../models/enums";
import { SelectedFilters, Tag, TreeNode } from "../../models/interfaces";

import PoweredByKorra from "../../components/poweredByKorra";
import common from "../search/common.css";
import mobile from "../search/mobile.css";
// import desktop from "../search/desktop.css";

import { get_AI_URI_BASE, get_DASHBOARD_URI_BASE } from "../../configs/env";
import { getInitialDocuments, getSourceElement } from "../search/getCall";
import { initialSelectedFilters } from "../../models/consts";
import widget from "../search/widget.css";
import {
  setBackHome,
  setExperienceName,
} from "../../redux/slices/appearanceSlice";
import logger from "../../logger";
import KeywordView from "./keywordView";

interface Props {
  workspaceId: string;
  kappId?: string;
  portalId?: string;
  workspaceAlias?: string;
  portalAlias?: string;
  q: string;
  back?: boolean;
  hideHeader?: boolean;
}

export const isSearchAgain = (q: string, search: any): boolean => {
  // it should be opposite 🤦‍♀️
  try {
    if (search.exactMatch) return false;
    return (
      search.lastQ === q &&
      JSON.stringify(search.selectedFilters.selectedKapps) ===
        JSON.stringify(search.lastSelectedFilters.selectedKapps) &&
      JSON.stringify(search.selectedFilters.selectedTags) ===
        JSON.stringify(search.lastSelectedFilters.selectedTags) &&
      search.exactMatch === search.lastExactMatch
    );
  } catch (error) {
    // console.log(error);
    return false;
  }
};

interface SelectedItem {
  arrayName: string;
  nestedKey: string;
  nestedValue: unknown;
}
const KeywordSearch: FunctionalComponent<Props> = (props: Props) => {
  const {
    workspaceId,
    kappId,
    portalId,
    workspaceAlias,
    portalAlias,
    q,
    back,
    hideHeader,
  } = props;
  const appearance = useAppSelector((state) => state.appearance);
  const search = useAppSelector((state) => state.search);
  const alias = useAppSelector((state) => state.alias);
  const globals = useAppSelector((state) => state.globals);

  const [loading, setLoading] = useState<boolean>(true);
  const [errorDesc, setError] = useState<string>("");
  const dispatch = useAppDispatch();
  const [selectedAnswerText, selectAnswer] = useState<string>("");
  const [textToShow, setTextToShow] = useState<string>("");
  // const [textRequested, setTextRequested] = useState<boolean>(false);
  const [blinkingCursor, setBlinkingCursor] = useState<boolean>(false);
  const [selectedDocumentType, setSelectedDocumentType] =
    useState<SelectedDocumentType>(SelectedDocumentType.All);
  const [showExtendedFilters, setShowExtendedFilters] =
    useState<boolean>(false);
  const [filtersLoaded, setFiltersLoaded] = useState<boolean>(false);
  const [showFiltersMobile, setShowFiltersMobile] = useState<boolean>(false);
  const [queryLimitOn, setQueryLimitOn] = useState<boolean>(false);
  const [showAll, setShowAll] = useState<boolean>(false);
  const [withGpt, setWithGpt] = useState<boolean>(true);
  const [noResults, setNoResults] = useState<boolean>(false);
  // const [noSources, setnoSources] = useState<boolean>(false);
  // const [NOANSWER, setNOANSWER] = useState<boolean>(false);
  const [yearRange, setYearRange] = useState<boolean>(false);
  const [tagYearFrom, setTagYearFrom] = useState<number>(0);
  const [tagYearTo, setTagYearTo] = useState<number>(0);
  const [isZeroIndex, setZeroIndex] = useState<boolean>(false);
  const [showFiltersBlock, setShowFiltersBlock] = useState<
    "years" | "nonYears" | "kapps" | null
  >(null);
  const [isPaying, setIsPaying] = useState<boolean>(true);
  const [updatedNestedTags, setUpdateNestedTags] = useState<TreeNode>();
  const [isEdge, setIsEdge] = useState(getIsEdge());
  const [autoOpenDoc, setAutoOpenDoc] = useState<any>(null);
  const [currentPage, setCurrentPage] = useState(1);
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const workspaceIdParam = urlParams.get("workspaceId");
    const kappIdParam = urlParams.get("kappId");
    const docGuidParam = urlParams.get("docGuid");
    const guidParam = urlParams.get("guid");
    const pageParam = urlParams.get("page");
    const typeParam = urlParams.get("type");
    const qParam = urlParams.get("q");

    if (
      workspaceIdParam &&
      kappIdParam &&
      docGuidParam &&
      guidParam &&
      typeParam
    ) {
      setAutoOpenDoc({
        type: typeParam,
        kapp: kappIdParam,
        docGuid: docGuidParam,
        guid: guidParam,
        page: pageParam || "0",
      });

      if (qParam) {
        dispatch(setLastQ(qParam));
        dispatch(setInputValue(qParam));
      }
    }
  }, []);

  const handleNestedTagChange = (data: any) => {
    setLoading(true);
    setUpdateNestedTags(data);
    const nestedTagArray = getSelectedNames(data.children);
    if (nestedTagArray) {
      dispatch(setSelectedNestedTags(nestedTagArray));
      setSearchResultsForPortal(
        "",
        "",
        search.selectedCategory,
        search?.inputValue,
        nestedTagArray,
        data
      );
    }
  };
  const handleCheckboxChange = (
    arrayName: string,
    nestedKey: string,
    nestedValue: unknown
  ) => {
    const WafersArrayName = "wafer_size";
    const wafers_200 = ["200mm", "200 mm"];
    const wafers_300 = ["300mm", "300 mm", "299-301mm"];
    const wafers_200_300 = ["200mm and 300mm", "200 mm/300 mm"];
    setLoading(true);
    const newSelection: SelectedItem = { arrayName, nestedKey, nestedValue };

    // Toggle the selection state
    const isSelected = search?.selectedCategory.some(
      (item) => item.nestedKey === nestedKey && item.nestedValue === nestedValue
    );

    if (arrayName === WafersArrayName) {
      let selections: SelectedItem[] = [];
      const mm200isSelected = search?.selectedCategory.some(
        (item) => item.nestedKey === "200mm"
      );
      const mm300isSelected = search?.selectedCategory.some(
        (item) => item.nestedKey === "300mm"
      );

      if (isSelected) {
        // If already selected, remove it

        if (nestedKey === "200mm") {
          if (mm300isSelected) {
            selections = search?.selectedCategory?.filter(
              (item: any) => !wafers_200.includes(item.nestedKey)
            );
            dispatch(setSelectedCategory(selections || []));
          } else {
            selections = search?.selectedCategory?.filter(
              (item: any) =>
                !wafers_200.includes(item.nestedKey) &&
                !wafers_200_300.includes(item.nestedKey)
            );
            dispatch(setSelectedCategory(selections || []));
          }
        } else {
          if (mm200isSelected) {
            selections = search?.selectedCategory?.filter(
              (item: any) => !wafers_300.includes(item.nestedKey)
            );
            dispatch(setSelectedCategory(selections || []));
          } else {
            selections = search?.selectedCategory?.filter(
              (item: any) =>
                !wafers_300.includes(item.nestedKey) &&
                !wafers_200_300.includes(item.nestedKey)
            );
            dispatch(setSelectedCategory(selections || []));
          }
        }
        setSearchResultsForPortal(
          "",
          "",
          [...selections],
          search?.inputValue,
          []
        );
        return;
      } else {
        let tempMixArray: string[] = [];
        // If not selected, add it
        if (nestedKey === "200mm") {
          if (mm300isSelected) {
            const selections_200 = wafers_200.map((value) => ({
              arrayName: WafersArrayName,
              nestedKey: value,
              nestedValue: nestedValue,
            }));
            selections = [...selections_200];
          } else {
            tempMixArray = [...wafers_200, ...wafers_200_300];
            const selections_200and300 = tempMixArray.map((value) => ({
              arrayName: WafersArrayName,
              nestedKey: value,
              nestedValue: nestedValue,
            }));
            selections = [...selections_200and300];
          }
        } else {
          let tempMixArray: string[] = [];
          if (mm200isSelected) {
            const selections_300 = wafers_300.map((value) => ({
              arrayName: WafersArrayName,
              nestedKey: value,
              nestedValue: nestedValue,
            }));
            selections = [...selections_300];
          } else {
            tempMixArray = [...wafers_300, ...wafers_200_300];
            const selections_200and300: SelectedItem[] = tempMixArray.map(
              (value) => ({
                arrayName: WafersArrayName,
                nestedKey: value,
                nestedValue: nestedValue,
              })
            );
            selections = [...selections_200and300];
          }
        }
        dispatch(
          setSelectedCategory([...search?.selectedCategory, ...selections])
        );
      }
      setSearchResultsForPortal(
        "",
        "",
        [...search?.selectedCategory, ...selections],
        search?.inputValue,
        []
      );
      return;
    }

    let tempArray: any = [];
    if (isSelected) {
      // If already selected, remove it

      const newTemp = search?.selectedCategory?.filter(
        (item: any) =>
          item.nestedKey !== nestedKey || item.nestedValue !== nestedValue
      );
      tempArray = [...newTemp];
      dispatch(setSelectedCategory(newTemp));
    } else {
      // If not selected, add it
      tempArray = [...search?.selectedCategory, newSelection];
      dispatch(setSelectedCategory(tempArray));
    }
    setSearchResultsForPortal("", "", tempArray, search?.inputValue, []);
  };
  const OnApplyFilters = () => {
    setLoading(true);
    setSearchResultsForPortal(
      "",
      "",
      search?.selectedCategory,
      search?.inputValue,
      search.selectedNestedTags
    );
  };
  const clearCategoryFilters = () => {
    setLoading(true);
    dispatch(setSelectedCategory([]));
    setInputValue("");
    setSearchResultsForPortal("", "", null, "", null);
  };
  const getSelectedItems = () => {
    const selectedKapps = search.kapps.filter((kapp) => kapp.selected);
    const selectedTags = search.tags.filter((tag) => tag.selected);

    const selectedItems = [
      ...selectedKapps.map((kapp) => ({ name: kapp.name, isKapp: true })),
      ...selectedTags.map((tag) => ({ name: tag.value })),
    ];

    return selectedItems;
  };

  const selectedItems = getSelectedItems();
  const isMobileOnly = appearance.narrowfactor || isMobileOnlyReact;

  useEffect(() => {
    if (showFiltersBlock) {
      setShowFiltersBlock(null);
    }
  }, [search.tags]);
  useEffect(() => {
    setListeners();
    dispatch(setBackHome(false));
    return () => {
      unsetListeners();
    };
  }, []);
  useEffect(() => {
    if (back) {
      clearAllFilters();
    }
  }, [back]);
  useEffect(() => {
    if (alias.workspaceId && alias.portalId) {
      setFilters();
    } else {
      // if it is kapp (alias.workspaceId && alias.portalId is not an criteria for kapp)
      if (alias.workspaceId && kappId) {
        setFiltersLoaded(true);
      }
      // setFiltersLoaded(true);
      setWithGpt(true); // gpt always on for preview
    }
  }, [alias]);

  useEffect(() => {
    if (getIsEdge() || (filtersLoaded && globals.sessionId)) {
      // clearAllFilters()
      if (isSearchAgain(q, search)) {
        setLoading(false);
        return;
      } else {
        setShowAll(
          search.selectedFilters.selectedDocumentType ==
            SelectedDocumentType.All &&
            search.selectedFilters.selectedKapps.length == 0 &&
            search.selectedFilters.selectedTags.length == 0
        );
        setLoading(true);
        if (portalId || alias.portalId || portalAlias)
          setSearchResultsForPortal(
            "",
            "",
            search?.selectedCategory,
            search?.inputValue,
            search.selectedNestedTags
          );
        else setSearchResultsForKapp();
      }
    }
  }, [
    search.selectedFilters,
    search.exactMatch,
    filtersLoaded,
    q,
    globals.sessionId,
    currentPage,
  ]);

  useEffect(() => {
    Utils.typeText(selectedAnswerText, (typedText: string) => {
      setTextToShow(typedText);
    });
  }, [selectedAnswerText]);

  useEffect(() => {
    try {
      if (
        (appearance.yearRangeEnabled || appearance.yearRangeEnabled2) &&
        search.tags?.length > 0
      ) {
        let _tagYearFrom = 0;
        let _tagYearTo = 0;
        search.tags.forEach((tag: Tag) => {
          if (tag.value?.length == 4 && !isNaN(Number(tag.value))) {
            const _tagYear = Number(tag.value);
            if (_tagYearFrom == 0 || _tagYear < _tagYearFrom) {
              _tagYearFrom = _tagYear;
            }
            if (_tagYearTo == 0 || _tagYear > _tagYearTo) {
              _tagYearTo = _tagYear;
            }
          }
        });
        if (_tagYearFrom != 0 && _tagYearTo != 0) {
          setYearRange(true);
          setTagYearFrom(_tagYearFrom);
          setTagYearTo(_tagYearTo);
        }
      }
    } catch (error) {
      // console.log(error);
    }
  }, [search.tags]);

  useEffect(() => {
    (async () => {
      if (workspaceId || alias.workspaceId) {
        const res = await fetch(
          `${get_AI_URI_BASE()}/payments/status?company_id=${
            workspaceId || alias.workspaceId
          }`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${globals.jwtUserIdToken}`,
            },
            method: "GET",
            mode: "cors",
          }
        );
        const status = await res.json();
        status["data"]["plan"] === "free" ? setIsPaying(false) : null;
      }
    })();
  }, [alias.workspaceId]);

  const routeTo = (r: any) => {
    route(r?.detail);
  };
  const setListeners = () => {
    (window as any).addEventListener("route-to", routeTo);
    window.addEventListener("click", function (event: any) {
      const extendedFiltersElement =
        document.getElementById("extended-filters");
      const yearRangeWrapper = document.getElementById("yearRangeWrapper");
      if (
        extendedFiltersElement &&
        !extendedFiltersElement.contains(event?.target)
      ) {
        setShowExtendedFilters(false);
      }

      if (yearRangeWrapper && !yearRangeWrapper.contains(event?.target)) {
        setShowFiltersBlock(null);
      }
    });
  };
  const unsetListeners = () => {
    (window as any).removeEventListener("route-to", routeTo);
    (window as any).removeEventListener("click", routeTo);
  };

  const setFilters = async (_portalId?: string) => {
    try {
      let _kapps = [];
      if (_portalId || portalId || alias.portalId) {
        try {
          if (search.kapps.length == 0) {
            const kappsResponse = await axios(
              `${get_DASHBOARD_URI_BASE()}/flow/kapps/portals/${
                _portalId || portalId || alias.portalId
              }`
            );
            if (kappsResponse?.data?.data?.length > 0) {
              _kapps = kappsResponse.data.data.map((kapp: any) => {
                kapp.selected = false;
                return kapp;
              });
              // get tags
              if (appearance.filtersType === "tags") {
                const tagsResponse = await axios(
                  `${get_DASHBOARD_URI_BASE()}/flow/tags/workspace/${
                    workspaceId || alias.workspaceId
                  }/kapps/${JSON.stringify(_kapps.map((kapp: any) => kapp.id))}`
                );
                if (tagsResponse?.data?.data?.length > 0) {
                  dispatch(setTags(tagsResponse.data.data));
                }
              }

              if (appearance.filtersType === "category") {
                const nestedTagesResponse = await axios(
                  `${get_AI_URI_BASE()}/doc-tagger/get_tag_trees/workspace_id/${
                    workspaceId || alias.workspaceId
                  }/kapps/${_kapps?.map((kapp: any) => kapp.id).join(",")}`
                );
                // get category
                if (!nestedTagesResponse?.data || isEdge) {
                  const categoryResponse = await axios(
                    `${get_DASHBOARD_URI_BASE()}/flow/tags/category/workspace/${
                      workspaceId || alias.workspaceId
                    }/kapps/${JSON.stringify(
                      _kapps.map((kapp: any) => kapp.id)
                    )}`
                  );
                  if (categoryResponse?.data?.data) {
                    dispatch(setCategories(categoryResponse?.data?.data));
                  }
                }
                if (nestedTagesResponse?.data && !isEdge) {
                  // Convert JSON data to the hierarchical structure
                  const convertedData: TreeNode[] = Object.entries(
                    nestedTagesResponse?.data
                  ).map(([key, value]: any) => convertJson(value, key));
                  let data = {
                    children: convertedData,
                  };
                  dispatch(setNestedTags(data));
                }
              }
            }
          } else {
            _kapps = JSON.parse(JSON.stringify(search.kapps)).map(
              (kapp: any) => {
                if (!kapp.selected) {
                  kapp.selected = false;
                }
                return kapp;
              }
            );
          }
        } catch (error: any) {
          // use descriptive error message
          logger.error({
            message: error?.message,
            stacktrace: error?.stack,
            portal_alias: portalAlias || alias.portalAlias,
          });
        }
      }
      setSelectedDocumentType(SelectedDocumentType.All);
      setFiltersLoaded(true);
      dispatch(setKapps(_kapps));
    } catch (error) {
      setFiltersLoaded(true);
    }

    setWithGpt(appearance.explanator);
  };

  /**
   * search and present
   */
  const searchAndDisplayResults = async (searchUrl: string | undefined) => {
    try {
      if (isEdge) {
        UpdateEdgeUserSessionTimeStamp();
      }
      setLoading(true);
      let response: any = {};

      if (searchUrl) {
        response = await getInitialDocuments(searchUrl, {});
      }

      const results = response?.results || [];
      let sources: any[] = [];

      for (let i = 0; i < results.length; i++) {
        const result = results[i];

        const srcElementResult = getSourceElement(
          result,
          alias,
          result?.search?._source?.action?.name,
          appearance.highlightPdf
        );

        sources.push(srcElementResult);
      }

      dispatch(
        setKeywordsDocuments({
          pages: response.pages,
          source: sources,
        })
      );
      setLoading(false);
    } catch (error) {
      console.error("Error in searchAndDisplayResults:", error);
      setError("An error occurred while fetching search results.");
      setLoading(false);
      dispatch(setKeywordsDocuments([])); // optional fallback
    }
  };

  /**
   * search portal
   * @param _workspaceId
   * @param _portalId
   */
  const setSearchResultsForPortal = async (
    _workspaceId?: string,
    _portalId?: string,
    categoryArray?: any,
    keywordsValue?: string,
    nestedTagArray?: any,
    data?: any
  ) => {
    try {
      if (data?.children?.length > 0) {
        dispatch(setNestedTags(data));
      }
      // setNoResults(false);
      // setError("");
      if (!(_workspaceId || workspaceId || alias.workspaceId)) return;
      // dispatch(setSummary(null));
      let searchUrl = get_AI_URI_BASE();
      // if (!withGpt) {
      //   searchUrl = get_AI_URI_BASE();
      // }
      let encordedQ = encorderQuestion(q);
      if (search.selectedFilters.selectedKapps.length == 0) {
        searchUrl += `/ai/client/document_search?query=${encordedQ}&company_id=${
          _workspaceId || workspaceId || alias.workspaceId
        }&portal_id=${
          _portalId || portalId || alias.portalId
        }&workspace_alias=${alias.workspaceAlias || ""}&portal_alias=${
          alias.portalAlias || ""
        }&num_scores=${
          appearance.yearRangeEnabled ? 150 : getSearchNumScores()
        }&session_id=${globals.sessionId}&page=${currentPage}
        `;
      } else {
        searchUrl += `/ai/client/document_search?query=${encordedQ}&company_id=${
          _workspaceId || workspaceId || alias.workspaceId
        }&portal_id=${
          _portalId || portalId || alias.portalId
        }&workspace_alias=${alias.workspaceAlias || ""}&portal_alias=${
          alias.portalAlias || ""
        }&num_scores=${
          appearance.yearRangeEnabled ? 150 : getSearchNumScores()
        }&session_id=${
          globals.sessionId
        }&kapp_list=[${search.selectedFilters.selectedKapps?.map(
          (selectedKapp: any) => `"${selectedKapp}"`
        )}]&page=${currentPage}`;
      }

      if (
        search.selectedFilters.selectedDocumentType !== SelectedDocumentType.All
      ) {
        searchUrl += `&filetype=${
          search.selectedFilters.selectedDocumentType ===
          SelectedDocumentType.Video
            ? "video"
            : "text_doc"
        }`;
      }
      const searchPayload: any = {};
      if (search?.selectedFilters?.selectedTags?.length > 0) {
        searchPayload.tags = [...search.selectedFilters.selectedTags];
      }
      if (nestedTagArray?.length > 0) {
        searchPayload.tree = [...nestedTagArray];
      }

      if (categoryArray?.length > 0) {
        const categories = categoryArray.reduce((acc: any, item: any) => {
          const { arrayName, nestedKey } = item;
          if (!acc[arrayName]) {
            acc[arrayName] = [];
          }
          acc[arrayName].push(nestedKey);
          return acc;
        }, {});
        searchPayload.categories = { ...categories };
      }
      if (
        searchPayload?.categories ||
        searchPayload?.tags?.length > 0 ||
        searchPayload?.tree?.length > 0
      ) {
        searchUrl += `&tags=${JSON.stringify(searchPayload)}`;
      }
      if (search?.exactMatch?.length > 0) {
        searchUrl += `&exact_match=${search?.exactMatch}`;
      }
      if (keywordsValue) {
        searchUrl += `&exact_match=${keywordsValue}`;
      }

      if (appearance.max_per_subject > 0) {
        searchUrl += `&max_per_subject=${appearance.max_per_subject}`;
      }

      let edgeUser: any = null;
      if (getIsEdge()) {
        edgeUser = await getEdgeUserLoginSession();
      }

      const interval = setInterval(() => {
        if (globals.sessionId || getIsEdge()) {
          searchAndDisplayResults(searchUrl);
          clearInterval(interval);
        }
      }, 500);
    } catch (error: any) {
      logger.error({
        message: error?.message,
        stacktrace: error.stack,
        portal_alias: portalAlias || alias.portalAlias,
        search_query: q,
      });

      dispatch(setLastQ(q));
      dispatch(setLastQResults([]));
      setError(
        "A network error occured when fetching search results. Please notify your system administrator."
      );
      setLoading(false);
      setBlinkingCursor(false);
    }
  };

  /**
   * search kapp
   */
  const setSearchResultsForKapp = async () => {
    try {
      setNoResults(false);
      setError("");
      let encordedQ = encorderQuestion(q);
      let searchUrl = `${get_AI_URI_BASE()}/ai/client/document_search?query=${encordedQ}&company_id=${workspaceId}&guide_id=${kappId}&num_scores=${getSearchNumScores()}&page=${currentPage}`;
      searchAndDisplayResults(searchUrl);
    } catch (error) {
      setLoading(false);
      setFiltersLoaded(true);
    }
  };

  // const setSelectedDocumentTypeFilter = (
  //   _selectedDocumentType: SelectedDocumentType
  // ) => {
  //   let newQueryParamsFilters: SelectedFilters = JSON.parse(
  //     JSON.stringify(search.selectedFilters)
  //   );
  //   newQueryParamsFilters.selectedDocumentType = _selectedDocumentType;
  //   dispatch(setSelectedFilters(newQueryParamsFilters));
  //   setSelectedDocumentType(_selectedDocumentType);
  // };
  const handleClearNestedTags = async () => {
    const nestedTagesResponse = await axios(
      `${get_AI_URI_BASE()}/doc-tagger/get_tag_trees/workspace_id/${
        workspaceId || alias.workspaceId
      }/kapps/${search?.kapps?.map((kapp) => kapp.id).join(",")}`
    );
    if (nestedTagesResponse?.data) {
      // Convert JSON data to the hierarchical structure
      const convertedData: TreeNode[] = Object.entries(
        nestedTagesResponse?.data
      ).map(([key, value]: any) => convertJson(value, key));
      let data = {
        children: convertedData,
      };
      dispatch(setNestedTags(data));
    }
  };
  const clearAllFilters = () => {
    if (search.selectedNestedTags?.length > 0) {
      handleClearNestedTags();
    }
    dispatch(setSelectedFilters(initialSelectedFilters));
    dispatch(setLastExactMatch(search.exactMatch));
    dispatch(setExactMatch(""));
    dispatch(setTypedYearFrom(""));
    dispatch(setTypedYearTo(""));
    dispatch(setYearFilterStatus(false));
    dispatch(setDocsFilterStatus(false));
    setSelectedDocumentType(SelectedDocumentType.All);
    dispatch(
      setKapps(
        JSON.parse(JSON.stringify(search.kapps)).map((kapp: any) => {
          kapp.selected = false;
          return kapp;
        })
      )
    );
    if (isMobileOnly) {
      setShowFiltersMobile(false);
    }
    let newTags = JSON.parse(JSON.stringify(search.tags));
    newTags = newTags.map((t: Tag) => {
      t.selected = false;
      return t;
    });
    if (search?.inputValue?.length > 0) {
      setLoading(true);
      dispatch(setInputValue(""));
      setSearchResultsForPortal("", "", null, "");
    }
    dispatch(setTags(newTags));
  };

  // const isInitalState = () => {
  //   let result = true;
  //   for (let kappIndex = 0; kappIndex < search.kapps.length; kappIndex++) {
  //     if (search.kapps[kappIndex]?.selected) {
  //       result = false;
  //       break;
  //     }
  //   }
  //   return result;
  // };

  const isAllTopics = () => {
    return (
      search.kapps.every((kapp: any) => kapp.selected) ||
      search.kapps.every((kapp: any) => !kapp.selected)
    );
  };

  const selectAllTopics = () => {
    let newQueryParamsFilters: SelectedFilters = JSON.parse(
      JSON.stringify(search.selectedFilters)
    );
    newQueryParamsFilters.selectedKapps = [];
    dispatch(setSelectedFilters(newQueryParamsFilters));
    dispatch(
      setKapps(
        JSON.parse(JSON.stringify(search.kapps)).map((kapp: any) => {
          kapp.selected = false;
          return kapp;
        })
      )
    );
  };

  // const filterSearchResults = (searchResult: any) => {
  //   if (!searchResult) return false;
  //   if (!isInitalState()) {
  //     const kapp = search.kapps.find(
  //       (kapp: any) => kapp.id === searchResult.kappId
  //     );
  //     if (!kapp?.selected) {
  //       return false;
  //     }
  //   }
  //   const docAllowType = ["pdf", "html", "docx"];

  //   switch (selectedDocumentType) {
  //     case SelectedDocumentType.All:
  //       return true;
  //     case SelectedDocumentType.Video:
  //       return searchResult?.search?._source?.action?.name === "video"; // && kapp ?!!!
  //     case SelectedDocumentType.Document:
  //       return docAllowType.includes(
  //         searchResult?.search?._source?.action?.name
  //       );
  //     // searchResult?.search?._source?.action?.name === "pdf" ||
  //     // searchResult?.search?._source?.action?.name === "html"
  //     default:
  //       return true;
  //   }
  // };

  const filtersToggleKappSelection = (kapp: any) => {
    let newQueryParamsFilters: SelectedFilters = JSON.parse(
      JSON.stringify(search.selectedFilters)
    );
    if (!kapp.selected) {
      newQueryParamsFilters.selectedKapps.push(kapp.id);
    } else {
      const index = newQueryParamsFilters.selectedKapps.findIndex(
        (selectedKappId) => kapp.id === selectedKappId
      );
      if (index > -1) {
        newQueryParamsFilters.selectedKapps.splice(index, 1);
      } else {
        logger.error({
          message: "index not found, something went wrong",
          portal_alias: portalAlias || alias.portalAlias,
        });
      }
    }

    let updatedKapps: any[] = JSON.parse(JSON.stringify(search.kapps)).map(
      (k: any) => {
        if (k.id === kapp.id) {
          if (k?.selected) {
            k.selected = false;
          } else {
            k.selected = true;
          }
          return k;
        } else {
          return k;
        }
      }
    );
    if (updatedKapps.every((kapp: any) => kapp.selected)) {
      updatedKapps = updatedKapps.map((kapp: any) => {
        kapp.selected = false;
        return kapp;
      });
      newQueryParamsFilters.selectedKapps = [];
    }
    dispatch(setSelectedFilters(newQueryParamsFilters));
    dispatch(setKapps(updatedKapps));
  };

  useEffect(() => {
    if (search.isChronological) {
      let newResults = JSON.parse(JSON.stringify(search.lastQResults));
      newResults = sortSearchResultsChronologically(
        newResults,
        search.chronologicalOrder
      );
      dispatch(setLastQResults(newResults));
    } else if (search.searchResltsBackup.length > 0) {
      dispatch(setLastQResults(search.searchResltsBackup));
    }
  }, [search.isChronological, search.chronologicalOrder]);

  // const countSelectedKapps = (): number => {
  //   return search.kapps.filter((kapp) => kapp.selected)?.length || 0;
  // };

  // const openMobileFilters = () => {
  //   setShowFiltersMobile(!showFiltersMobile);
  //   if (!showFiltersMobile) {
  //     document.body.style.overflow = "hidden";
  //   } else {
  //     document.body.style.overflow = "";
  //   }
  // };

  // const handleCloseWidget = () => {
  //   window.parent.postMessage("unloadCogWidget", "*");
  // };

  // const fix_bullets = (text: string, type: string) => {
  //   if (type === "claude") {
  //     text = text.replace(/(\\n\\n\s*-)/g, "\n • ");
  //     text = text.replace(/(\\n\s*-)/g, "\n • ");

  //     text = text.replace(/\\•/g, ".\n   - ");
  //     text = text.replace(/(\\n|n\\)/g, " ");
  //   } else {
  //     if (text[0] === "-") {
  //       text = text.substring(1);
  //       if (text[0] !== "•") {
  //         text = " • " + text;
  //       }
  //     }

  //     text = text.replace(/(?:\.\s*-|^\s*-|\.\s*\\n\s*-)/gm, ".\n • ");
  //   }
  //   return text;
  // };

  // const fixNewline = (text: string) => {
  //   const rules = [{ regex: /\\+n/g, replacement: "\n" }];

  //   let markdown = text;
  //   rules.forEach((rule) => {
  //     markdown = markdown.replace(rule.regex, rule.replacement);
  //   });

  //   return markdown;
  // };

  // const fixLines = (text: string, style: string, type: string) => {
  //   if (style === "Bullets") {
  //     text = fix_bullets(text, type);
  //   } else {
  //     text = text.replace(/(\\n|n\\)/g, " ");
  //   }

  //   const startTagRegex = /^[a-zA-Z]+>/;
  //   const endTagRegex = /<\/[a-zA-Z]+$/;

  //   let fixedText = text;

  //   // Fix missing '<' at the beginning
  //   if (startTagRegex.test(text)) {
  //     fixedText = "<" + fixedText;
  //   }

  //   // Fix missing '>' at the end
  //   if (endTagRegex.test(text)) {
  //     fixedText = fixedText + ">";
  //   }

  //   const lines = fixNewline(fixedText).split("\n");

  //   return (
  //     <Fragment>
  //       {lines.map((line, index) => {
  //         if (index === 0) {
  //           const words = line.split(" ");
  //           const modifiedWords = [];
  //           let imageCount = 0;
  //           const urlParams = new URLSearchParams(window.location.search);
  //           const showImages = urlParams.get("TIRA") === "1";

  //           for (let i = 0; i < words.length; i++) {
  //             modifiedWords.push(words[i]);
  //             if (showImages && (i + 1) % 11 === 0 && imageCount < 2) {
  //               const imgSrc =
  //                 imageCount === 0
  //                   ? "/assets/figure-5-1.png"
  //                   : "/assets/figure-5-2.png";
  //               modifiedWords.push(
  //                 `<img src="${imgSrc}" height=50px alt="figure" style="height:3em; vertical-align:middle;" />`
  //               );
  //               imageCount++;
  //             }
  //           }

  //           const modifiedLine = modifiedWords.join(" ");

  //           return (
  //             <div key={index}>
  //               <span
  //                 style={{
  //                   paddingRight: line.startsWith(" - ") ? "15px" : undefined,
  //                 }}
  //                 dangerouslySetInnerHTML={{ __html: modifiedLine }}
  //               />
  //               {lines.length === 1 && blinkingCursor && (
  //                 <span className={desktop.blinkingCursor}>|</span>
  //               )}
  //             </div>
  //           );
  //         } else {
  //           return (
  //             <div key={index}>
  //               <span
  //                 style={{
  //                   paddingRight: line.startsWith(" - ") ? "15px" : undefined,
  //                 }}
  //                 dangerouslySetInnerHTML={{ __html: line }}
  //               />
  //               {index === lines.length - 1 && blinkingCursor && (
  //                 <span className={desktop.blinkingCursor}>|</span>
  //               )}
  //             </div>
  //           );
  //         }
  //       })}
  //     </Fragment>
  //   );
  // };

  const tagClicked = (tag: Tag) => {
    let newTags = JSON.parse(JSON.stringify(search.tags));
    newTags = newTags.map((t: Tag) => {
      if (
        // t.workspaceId === tag.workspaceId &&
        // t.kappId === tag.kappId &&
        // t.docGuid === tag.docGuid &&
        t.value === tag.value
      ) {
        t.selected = !t.selected;
      }
      return t;
    });
    dispatch(setTags(newTags));
    let newQueryParamsFilters: SelectedFilters = JSON.parse(
      JSON.stringify(search.selectedFilters)
    );
    newQueryParamsFilters.selectedTags = (
      newTags
        ?.filter((t: Tag) => t.selected)
        ?.map((t: Tag) => t.value) as string[]
    )?.filter((value: string, index: number, self: string[]) => {
      if (self.slice(0, index).indexOf(value) === -1) {
        return true;
      }
      return false;
    });
    dispatch(setSelectedFilters(newQueryParamsFilters));
  };
  const removeTag = (item: any) => {
    if (item.isKapp) {
      let kapp = search.kapps.find((k) => item.name === k.name);
      if (kapp) {
        filtersToggleKappSelection(kapp);
      }
    } else {
      let tag = search.tags.find((t) => item.name === t.value);
      if (tag) {
        tagClicked(tag);
      }
    }
    // console.log("item", item);
  };

  // const oldChapterResolver = (result: any) => {
  //   return result?.search?._source?.internal_path?.length > 0
  //     ? result.search._source.internal_path[
  //         result.search._source.internal_path.length - 1
  //       ]
  //     : result?.search?._source?.chapter.length > 0
  //     ? result?.search?._source?.chapter
  //     : result?.search?._source?.subject;
  // };

  // const getChapterName = (result: any) => {
  //   if (
  //     result?.search?._source?.srcUrl?.split(".")?.pop() === "pdf" &&
  //     appearance.showManyHeaders &&
  //     result?.search?._source?.chapter
  //   ) {
  //     return `${result?.search?._source?.chapter} / ${oldChapterResolver(
  //       result
  //     )}`;
  //   }
  //   return oldChapterResolver(result);
  // };

  // const getSearchItemType = (result: any): SearchItemType => {
  //   switch (result?.search?._source?.action?.name) {
  //     case "video":
  //       return SearchItemType.Video;
  //     case "pdf":
  //       return SearchItemType.Pdf;
  //     case "html":
  //       return SearchItemType.Html;
  //     case "xls":
  //       return SearchItemType.Sheet;
  //     default:
  //       return SearchItemType.Pdf;
  //   }
  // };

  useEffect(() => {
    // else setIsLoading(false);
    setListeners();
    if (appearance.experienceName === "Korra Knowledge Experience") {
      (async () => {
        try {
          if (
            (portalId || alias.portalId) &&
            (workspaceId || alias.workspaceId)
          ) {
            const experienceInfo = await Utils.secureGet(
              `${get_DASHBOARD_URI_BASE()}/portals/${
                portalId || alias.portalId
              }/workspaces/${workspaceId || alias.workspaceId}`,
              {
                Authorization: `Bearer ${globals.jwtUserIdToken}`,
                "Portal-Id": portalId || alias.portalId,
              }
            );
            dispatch(
              setExperienceName(
                experienceInfo?.data?.data?.name || "Korra Knowledge Experience"
              )
            );
          }
        } catch (error: any) {
          logger.error({
            message: error.message,
            stacktrace: error.stack,
            portal_alias: portalAlias || alias.portalAlias,
          });
        }
      })();
    }
    return () => {
      unsetListeners();
    };
  }, [alias]);

  // Inject toolbar & copy button into LLM-generated code blocks
  useEffect(() => {
    const enhanceCodeBlock = (block: HTMLElement) => {
      if (!block || block.dataset.enhanced === "1") return;

      // Build toolbar
      const toolbar = document.createElement("div");
      toolbar.className = "cb-toolbar";

      const lang = document.createElement("span");
      lang.className = "cb-lang";
      lang.textContent = block.dataset.lang || "";

      const btn = document.createElement("button");
      btn.className = "cb-copy";
      btn.type = "button";
      btn.textContent = "Copy";

      btn.addEventListener("click", () => {
        const pre = block.querySelector("pre");
        const text = pre ? (pre as HTMLElement).innerText : "";
        const onDone = () => {
          const old = btn.textContent;
          btn.textContent = "Copied!";
          setTimeout(() => (btn.textContent = old || "Copy"), 1500);
        };

        if (navigator.clipboard?.writeText) {
          navigator.clipboard
            .writeText(text)
            .then(onDone)
            .catch(() => {
              // Fallback
              const ta = document.createElement("textarea");
              ta.value = text;
              ta.style.position = "fixed";
              ta.style.opacity = "0";
              document.body.appendChild(ta);
              ta.select();
              try {
                document.execCommand("copy");
                onDone();
              } catch {}
              document.body.removeChild(ta);
            });
        } else {
          // Fallback
          const ta = document.createElement("textarea");
          ta.value = text;
          ta.style.position = "fixed";
          ta.style.opacity = "0";
          document.body.appendChild(ta);
          ta.select();
          try {
            document.execCommand("copy");
            onDone();
          } catch {}
          document.body.removeChild(ta);
        }
      });

      toolbar.appendChild(lang);
      toolbar.appendChild(btn);

      // Insert toolbar as the first child of the block
      block.insertBefore(toolbar, block.firstChild);

      // Mark so we don't duplicate
      block.dataset.enhanced = "1";
    };

    // Enhance any existing blocks immediately
    document
      .querySelectorAll<HTMLElement>(".code_block:not([data-enhanced='1'])")
      .forEach(enhanceCodeBlock);

    // Observe future inserts (useful if your LLM streams content in)
    const observer = new MutationObserver((mutations) => {
      for (const m of mutations) {
        m.addedNodes.forEach((node) => {
          if (!(node instanceof HTMLElement)) return;

          if (node.matches?.(".code_block")) {
            enhanceCodeBlock(node);
          }
          // Also scan descendants if a container was inserted
          node
            .querySelectorAll?.(".code_block:not([data-enhanced='1'])")
            .forEach((n) => enhanceCodeBlock(n as HTMLElement));
        });
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => observer.disconnect();
  }, []);

  const filterTagsForUI = (tag: Tag) => {
    // if all kapps selected, show all tags
    if (isAllTopics()) {
      return true;
    }
    // if kapp selected, show tags for that kapp
    if (
      search.kapps.find((kapp: any) => kapp.selected && kapp.id === tag.kappId)
    ) {
      return true;
    }
    return false;
  };

  const layout = (
    <div className={widget.wrapper}>
      {/* {expandView} */}
      {appearance.mode === "widget" && !isPaying && <PoweredByKorra />}
      <div
        className={isMobileOnly ? mobile.wrapper : common.wrapper}
        style={{ overflowY: "auto" }}
      >
        {/* Expand view */}
        {appearance.mode === "widget" ||
        appearance.backgroundImage ||
        !appearance.loaded ? null : isPaying ? null : (
          <PoweredByKorra />
        )}

        {/* powered by for widget */}

        <KeywordView
          workspaceId={workspaceId}
          // kappId={kappId}
          portalId={portalId}
          workspaceAlias={workspaceAlias}
          portalAlias={portalAlias}
          q={q}
          selectedItems={selectedItems}
          // withGpt={withGpt}
          // textRequested={textRequested}
          // textToShow={textToShow}
          // showExtendedFilters={showExtendedFilters}
          // setShowExtendedFilters={setShowExtendedFilters}
          // isInitalState={isInitalState}
          // countSelectedKapps={countSelectedKapps}
          selectAllTopics={selectAllTopics}
          isAllTopics={isAllTopics}
          filtersToggleKappSelection={filtersToggleKappSelection}
          filterTagsForUI={filterTagsForUI}
          tagClicked={tagClicked}
          removeTag={removeTag}
          clearAllFilters={clearAllFilters}
          isMobileOnly={isMobileOnly}
          loading={loading}
          // filtersLoaded={filtersLoaded}
          // noResults={noResults}
          // noSources={noSources}
          // NOANSWER={NOANSWER}
          errorDesc={errorDesc}
          // selectedDocumentType={selectedDocumentType}
          // fixLines={fixLines}
          // showAll={showAll}
          // setShowAll={setShowAll}
          // setSelectedDocumentTypeFilter={setSelectedDocumentTypeFilter}
          // filterSearchResults={filterSearchResults}
          // getSearchItemType={getSearchItemType}
          // getChapterName={getChapterName}
          queryLimitOn={queryLimitOn}
          isZeroIndex={isZeroIndex}
          handleCheckboxChange={handleCheckboxChange}
          selectedCategory={search.selectedCategory}
          OnApplyFilters={OnApplyFilters}
          clearCategoryFilters={clearCategoryFilters}
          handleNestedTagChange={handleNestedTagChange}
          setUpdateNestedTags={setUpdateNestedTags}
          autoOpenDoc={autoOpenDoc}
          hideHeader={hideHeader}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        />
      </div>
    </div>
  );

  return layout;
};

export default KeywordSearch;
